import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { ButtonClose } from '@doltech/ui/lib/figma/ButtonClose/ButtonClose';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { SkillEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ImageLogoWithoutName } from '@doltech/images/LogoWithoutName';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { flexGap } from '@doltech/utils/lib/css-style';
import { ListeningReviewTimeLimit } from '../../../../components/TimeLimit/ListeningReviewTimeLimit';
import { TimeLimit } from '../../../../components/TimeLimit/TimeLimit';
import { useTestSubmissionStore } from '../../../../model/test-submissions.hook';

export const DO_TEST_MOBILE_TOPBAR_HEIGHT = 56;

interface DoTestHeaderProps {
  totalPassage?: number;
  totalTime?: number;
  testName: string;
  testSectionName?: string;
  onSubmit?: any;
  onQuit?: () => void;
  showQuitButton?: boolean;
}

const Main = styled.div<{ totalPassage }>`
  padding: 8px 16px;
  max-height: ${DO_TEST_MOBILE_TOPBAR_HEIGHT}px;
  box-shadow: inset 0 -1px 0 ${colorsV2.gray10};

  display: grid;
  grid-template-columns: auto max-content;
  gap: 16px;
  justify-content: space-between;
`;

const Timer = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(12)}

  .test-info {
    height: 36px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    word-break: break-all;
  }
`;

const LeftArea = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(4)}
`;

export const DoTestHeader = observer((props: DoTestHeaderProps) => {
  const testSubmissionStore = useTestSubmissionStore();
  const { totalPassage, testName, testSectionName, onQuit, showQuitButton = true } = props;
  const { skill, isReviewing } = testSubmissionStore;

  return (
    <Main className="layout-header" totalPassage={Boolean(totalPassage)}>
      <LeftArea>
        <ImageLogoWithoutName color={colorsV2.primary100} size={32} />

        <div>
          <ResponsiveTypography.Paragraph
            variant="bold/16-24"
            color="gray180"
            ellipsis={{ tooltip: true }}
          >
            {testName}
          </ResponsiveTypography.Paragraph>
          {testSectionName && (
            <ResponsiveTypography.Paragraph
              variant="regular/14-20"
              color="gray140"
              ellipsis={{ tooltip: true }}
            >
              {testSectionName}
            </ResponsiveTypography.Paragraph>
          )}
        </div>
      </LeftArea>

      <Timer>
        <div>
          {totalPassage && (
            <div className="test-info">
              {skill === SkillEnum.LISTENING && isReviewing ? (
                <ListeningReviewTimeLimit />
              ) : (
                <TimeLimit />
              )}
            </div>
          )}
        </div>
        {showQuitButton && (
          <div className="section-left">
            <ButtonClose size="large" onClick={onQuit}>
              <IconOtherClose />
            </ButtonClose>
          </div>
        )}
      </Timer>
    </Main>
  );
});
